/* La galerie en situation de la fiche (lot 02 du couloir catalogue).

   De vraies photos Gelato, la famille posée sur l'objet (`machines/shop/situations.py`) :
     · sans famille : la famille d'EXEMPLE, assets du thème, lus dans le JSON du snippet GÉNÉRÉ
       `tms-situations` (une variante par couleur, le sens de la famille d'exemple) ;
     · avec famille : SES photos, servies par la galerie (`GET /situation/…`), que le bloc d'app annonce
       pour la variante qu'il imprime (`tms:situations` : couleur choisie, sens de l'effectif).
   🔴 CE FICHIER NE DÉCIDE RIEN DE CE QUI S'IMPRIME : la variante, le verrou et le panier sont au bloc
   (`tms-gallery.js`). Il ne fait que montrer des photos — une erreur ici laisse la galerie d'exemple,
   jamais un panier ouvert.
   Grande photo + vignettes au bureau ; balayage (scroll-snap) + points au téléphone (tms-fiche.css). */
(function () {
  "use strict";

  function lireJSON(n) {
    if (!n) return null;
    try {
      return JSON.parse(n.textContent || "null");
    } catch (e) {
      console.error("[tms-fiche] JSON illisible : la galerie garde ses photos", e);
      return null;
    }
  }

  function initGalerie(racine) {
    var section = racine.closest(".shopify-section") || document;
    var piste = racine.querySelector("[data-tms-galerie-piste]");
    var vignettes = racine.querySelector("[data-tms-galerie-vignettes]");
    var points = racine.querySelector("[data-tms-galerie-points]");
    var qui = racine.querySelector("[data-tms-galerie-qui]");
    var legende = racine.querySelector("[data-tms-galerie-legende]");
    if (!piste) return;
    var genre = racine.getAttribute("data-tms-genre") || "";
    /* Lot 01 boutique-langue : chaque texte écrit ici vient d'un `data-t-*` de la galerie, posé par la fiche dans la langue
       de la page ; l'anglais en second argument n'est que le repli d'une galerie rendue sans eux. */
    function tr(cle, defaut) { return racine.getAttribute("data-t-" + cle) || defaut; }
    function note(texte) {
      var m = /^Shown (in|on) (.+); yours is (.+)\.$/.exec(texte || "");
      if (!m) return texte;
      var mots = tr("mots", "").split("|");
      var lib = function (v) {
        /* « ¶ » marque la fin, comme dans tms-valeur.liquid : « in¶ » ne vise que l'unité finale. */
        v += "\u00b6";
        mots.forEach(function (p) { var ab = p.split("="); if (ab.length === 2) v = v.split(ab[0]).join(ab[1]); });
        return v.split("\u00b6").join("");
      };
      return tr(m[1] === "on" ? "note-modele" : "note-taille", "Shown " + m[1] + " %A%; yours is %B%.")
        .replace("%A%", lib(m[2])).replace("%B%", lib(m[3]));
    }
    var cleDefaut = racine.getAttribute("data-tms-cle") || "";
    var exemples = lireJSON(section.querySelector("script[data-tms-situations-exemple]")) || {};
    // Lot 10 : le snippet est COMPACT ({listes, v} : une liste par jeu de photos, un indice par variante).
    if (exemples.listes && exemples.v) {
      /* Lot 14 : les textes distincts vivent une fois dans `textes` ; chaque photo en porte l'indice `t`. */
      if (exemples.textes) {
        exemples.listes.forEach(function (l) {
          l.forEach(function (p) {
            if (typeof p.t === "number" && p.texte == null) p.texte = exemples.textes[p.t] || "";
          });
        });
      }
      var deplie = {};
      Object.keys(exemples.v).forEach(function (k) { deplie[k] = exemples.listes[exemples.v[k]]; });
      exemples = deplie;
    }
    /* Lot 18 : le 600 px et le 200 px ne sont plus écrits (snippet sous 256 Kio) ; ils se DÉRIVENT de `src`
       comme `asset_img_url` les sert (`_600x` / `_200x` avant `.jpg`, même `?v=`, mesuré servi). */
    Object.keys(exemples).forEach(function (k) {
      (Array.isArray(exemples[k]) ? exemples[k] : []).forEach(function (p) {
        if (!p || !p.src || !/\.jpg(\?|$)/.test(p.src)) return;
        if (!p.moyen) p.moyen = p.src.replace(/\.jpg(\?|$)/, "_600x.jpg$1");
        if (!p.mini) p.mini = p.src.replace(/\.jpg(\?|$)/, "_200x.jpg$1");
      });
    });
    /* Lot 13 comptes (D9) : une variante HORS VENTE (le « cœur + dos » caché) n'est jamais choisie ni montrée. */
    var variantes = (lireJSON(section.querySelector("script[data-tms-variantes]")) || []).filter(function (v) {
      return v.dispo !== false;
    });
    var legendeExemple = legende ? Array.prototype.map.call(legende.childNodes, function (n) {
      return n.cloneNode(true);
    }) : [];
    var famille = null;
    var actif = 0;

    function photos() {
      return Array.prototype.slice.call(piste.querySelectorAll("[data-tms-galerie-photo]"));
    }

    function coche(attr) {
      var c = section.querySelector("input[" + attr + "]:checked");
      return c ? c.value : "";
    }

    /* 🔴 LOT 14 CATALOGUE (décision 4) : « Orientation » n'existe que pour une taille 3:4, 2:3 ou A (`tms.orientables`,
       posé par shopify_sync) ; le 5:4 garde son sens interne (décision 8). Montré ou caché AVANT le bloc (écouteur en
       capture, plus bas) : le bloc lit le sens seulement quand le choix est montré. Un sens sans variante pour la taille
       et la couleur cochées est grisé, et l'autre coché à sa place. */
    var orientations = section.querySelector("[data-tms-orientations]");
    var orientables = orientations ? (orientations.getAttribute("data-tms-orientables") || "").split("|") : [];

    function sensMontre() {
      return orientations && !orientations.hidden ? coche("data-tms-sens") : "";
    }

    function suivreOrientation() {
      if (!orientations) return;
      var taille = coche("data-tms-taille"), couleur = coche("data-tms-couleur");
      orientations.hidden = orientables.indexOf(taille) < 0;
      if (orientations.hidden) return;
      var premier = null, perdu = false;
      Array.prototype.forEach.call(orientations.querySelectorAll("input[data-tms-sens]"), function (r) {
        var ok = variantes.some(function (x) {
          return x.taille === taille && x.sens === r.value && (!couleur || x.couleur === couleur);
        });
        r.disabled = !ok;
        if (ok && !premier) premier = r;
        if (!ok && r.checked) perdu = true;
      });
      if (perdu && premier) premier.checked = true;
    }

    /* La variante d'EXEMPLE de la taille et de la couleur cochées : celle que le snippet illustre. */
    function cleExemple() {
      var couleur = coche("data-tms-couleur");
      var taille = coche("data-tms-taille");
      /* Lot 06 : le placement choisi (cœur ou grand) a ses propres photos quand il en a. */
      var emplacement = coche("data-tms-emplacement");
      /* Lot 14 : le sens choisi (« Orientation »), quand le choix est montré. */
      var sens = sensMontre();
      /* Lot 19 : le papier et l'épaisseur cochés — la 4 cm montre la photo de la slim AVEC sa note (revue du lot 19). */
      var papier = coche("data-tms-papier"), epaisseur = coche("data-tms-epaisseur");
      /* Sinon, celles de la même couleur et taille à l'autre placement — jamais une autre couleur. */
      for (var passe = 0; passe < 2; passe++) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          if ((!couleur || v.couleur === couleur) && (!taille || v.taille === taille) &&
              (passe || !emplacement || v.emplacement === emplacement) && (passe || !sens || v.sens === sens) &&
              (passe || !papier || v.papier === papier) && (passe || !epaisseur || v.epaisseur === epaisseur) &&
              exemples[v.gabarit]) {
            return v.gabarit;
          }
        }
      }
      return exemples[cleDefaut] ? cleDefaut : null;
    }

    /* 🔴 LOT 03 CATALOGUE : LE PRIX ET LA MATIÈRE SUIVENT LA TAILLE. Ils sont rendus par le serveur pour la
       variante de la page ; une autre taille cochée les remplace par ceux de SA variante (JSON de la section).
       Ce n'est qu'un affichage : la variante ajoutée au panier est posée par le bloc d'app. */
    function suivreTaille() {
      var taille = coche("data-tms-taille");
      /* Lot 09 : le PAPIER d'une carte change la matière affichée (même prix) — même règle, sans taille. */
      var papier = coche("data-tms-papier");
      if (papier && !taille) {
        var vp = variantes.filter(function (x) { return x.papier === papier; })[0];
        if (vp && vp.matiere) section.querySelectorAll("[data-tms-matiere]").forEach(function (n) { n.textContent = vp.matiere; });
        if (vp && vp.prix) section.querySelectorAll("[data-tms-prix]").forEach(function (n) { n.textContent = vp.prix; });
        return;
      }
      if (!taille) return;
      /* Lot 07 : la VARIANTE cochée (taille ET couleur) — le mug magique n'a pas le prix du 11 oz blanc.
         Lot 19 : et son papier ou son épaisseur — une toile 4 cm n'a pas le prix de la slim. */
      var couleur = coche("data-tms-couleur"), epaisseur = coche("data-tms-epaisseur");
      var v = variantes.filter(function (x) {
        return x.taille === taille && (!couleur || x.couleur === couleur) && (!papier || x.papier === papier) &&
          (!epaisseur || x.epaisseur === epaisseur);
      })[0] || variantes.filter(function (x) { return x.taille === taille; })[0];
      if (!v) return;
      if (v.prix) section.querySelectorAll("[data-tms-prix]").forEach(function (n) { n.textContent = v.prix; });
      if (v.matiere) section.querySelectorAll("[data-tms-matiere]").forEach(function (n) { n.textContent = v.matiere; });
    }

    function choisir(i, defiler) {
      var ps = photos();
      if (!ps.length) return;
      actif = Math.max(0, Math.min(i, ps.length - 1));
      if (defiler) {
        /* ⚠️ Animé seulement sans « réduire les animations » (prefers-reduced-motion). */
        var calme = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        piste.scrollTo({ left: ps[actif].offsetLeft, behavior: calme ? "auto" : "smooth" });
      }
      /* (lot 27) la vue « impression » de la fiche (posée devant par initFiche) n'est pas une photo : hors du compte. */
      Array.prototype.forEach.call(vignettes ? vignettes.querySelectorAll(".galerie-sit__vignette:not(.galerie-sit__vignette--impression)") : [], function (b, k) {
        b.setAttribute("aria-current", k === actif ? "true" : "false");
      });
      Array.prototype.forEach.call(points ? points.children : [], function (p, k) {
        if (k === actif) p.setAttribute("data-actif", "");
        else p.removeAttribute("data-actif");
      });
    }

    /* Vignettes et points, toujours DÉRIVÉS des photos présentes : jamais une liste à tenir à côté.
       ⚠️ Sans miniature (photos de la famille, pleine taille), une vignette ne se charge qu'APRÈS la grande
       photo : quatre vignettes visibles au bureau ne passent pas devant elle (revue du lot 02). */
    /* (lot 22 comptes) `poses[k]` : de quoi COMPOSER la vignette k chez le client (la même recette que sa photo). */
    function batirNavigation(minis, poses) {
      var ps = photos();
      /* (lot 03 boutique-chat, D-d) chaque photo est un bouton : clic, Entrée ou Espace l'ouvrent en plein écran. Son nom
         reprend le texte de la photo, qu'un nom d'accessibilité remplacerait sinon. */
      ps.forEach(function (f, k) {
        var im = f.querySelector("img");
        f.tabIndex = 0;
        f.setAttribute("role", "button");
        f.setAttribute("aria-label", ((im && im.alt) || tr("photo", "Photo %N%").replace("%N%", k + 1)) + tr("ouvrir", " (open full screen)"));
      });
      if (vignettes) {
        vignettes.textContent = "";
        /* (lot 27) sur la fiche, le rail des vues existe dès UNE photo (la maquette v2 l'a toujours). */
        if (ps.length > 1 || (ps.length && racine.closest(".fiche"))) {
          ps.forEach(function (f, k) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = "galerie-sit__vignette";
            b.setAttribute("aria-label", tr("photo-sur", "Photo %K% of %N%").replace("%K%", k + 1).replace("%N%", ps.length));
            var im = document.createElement("img");
            var src = f.querySelector("img");
            var mini = minis && minis[k];
            var poser = poses && poses[k];
            if (mini) im.src = mini;
            else if (poser) {
              /* composée une fois dans le document (`montrer` pose l'image À CÔTÉ de l'<img>), plus bas */
            } else if (src) {
              /* (revue lot 23) un autre nom que `poser` : le redéclarer en faisait la pose, appelée tout de suite plus bas */
              var charger = function () { im.src = src.currentSrc || src.src; };
              var premiere = ps[0].querySelector("img");
              if (!premiere || premiere.complete) charger();
              else {
                premiere.addEventListener("load", charger, { once: true });
                premiere.addEventListener("error", charger, { once: true });
              }
            }
            im.alt = "";
            im.loading = "lazy";
            im.decoding = "async";
            b.appendChild(im);
            if (!mini && poser) poser(im);
            b.addEventListener("click", function () {
              choisir(k, true);
            });
            vignettes.appendChild(b);
          });
        }
      }
      if (points) {
        points.textContent = "";
        if (ps.length > 1) {
          ps.forEach(function () {
            var p = document.createElement("span");
            p.className = "galerie-sit__point";
            points.appendChild(p);
          });
        }
      }
      choisir(0, false);
    }

    /* Remplace les photos. ⚠️ La première se charge tout de suite (c'est la plus grande image de la page),
       les autres à la demande : le balayage et les vignettes les feront venir. */
    function peindre(liste, sienne) {
      /* (lot 02 boutique-chat, décision d'Alex) les photos d'une famille EXEMPLE (annoncée par le bloc) : ce n'est pas
         la famille du visiteur, l'étiquette, les textes et la légende disent « Example family ». */
      var exemple = sienne && !!(famille && famille.exemple);
      var nom = exemple ? tr("famille-exemple", "Example family") : tr("sa-famille", "Your family");
      piste.textContent = "";
      liste.forEach(function (p, k) {
        var f = document.createElement("figure");
        f.className = "galerie-sit__photo";
        f.setAttribute("data-tms-galerie-photo", "");
        var im = document.createElement("img");
        if (!p.poser) im.src = p.src;
        /* (lot 03 boutique-chat, revue) le repli d'une photo composée : ce que son plein écran montre. */
        else f.__tmsRepli = p.src;
        if (p.moyen) {
          im.srcset = p.moyen + " 600w, " + p.src + " " + (p.l || 1000) + "w";
          im.sizes = "(max-width: 760px) 92vw, 480px";
        }
        im.alt = (sienne && !exemple ? tr("alt-sienne", "Your family on the " + genre + ", %TEXTE%")
          : tr("alt-exemple", "Our example family on the " + genre + ", %TEXTE%")).replace("%TEXTE%", p.texte).replace("%N%", k + 1);
        if (p.l && p.h) {
          im.width = p.l;
          im.height = p.h;
        }
        im.loading = k === 0 ? "eager" : "lazy";
        im.decoding = "async";
        /* 🔴 Une photo de la famille qui ne vient pas (409 : noms changés, 503 : API injoignable) ne laisse
           pas un cadre vide : la galerie revient à l'exemple de la même couleur (revue du lot 02). */
        if (sienne) {
          im.addEventListener("error", function () {
            if (famille && piste.contains(im)) {
              console.warn("[tms-fiche] photo de la famille indisponible : retour à l'exemple", im.src);
              famille = null;
              peindreExemple();
            }
          }, { once: true });
        }
        f.appendChild(im);
        piste.appendChild(f);
        /* 🔴 (lot 22 comptes) la photo de SA famille composée par son navigateur (dans le document : la composition se
           pose à côté de l'<img>) ; l'adresse ci-dessus reste son repli, avec le même retour à l'exemple. */
        if (p.poser) p.poser(im);
      });
      piste.scrollLeft = 0;
      batirNavigation(liste.map(function (p) { return p.mini || ""; }), liste.map(function (p) { return p.poser || null; }));
      racine.setAttribute("data-tms-galerie-famille", sienne ? "oui" : "non");
      if (qui) qui.textContent = sienne ? nom : tr("exemple", "Example");
      if (legende) {
        /* ⚠️ DOM, jamais `innerHTML` : le genre vient d'un metafield. L'exemple reprend ses nœuds d'origine. */
        legende.textContent = "";
        if (sienne) {
          var b = document.createElement("b");
          b.textContent = nom;
          legende.appendChild(b);
          /* Lot 09 : « in the colour you chose » seulement quand la fiche fait CHOISIR une couleur (une carte n'en a pas). */
          var avecCouleur = section.querySelector("input[data-tms-couleur]");
          legende.appendChild(document.createTextNode(avecCouleur
            ? tr("legende-couleur", ", on real photos of the " + genre + " in the colour you chose.")
            : tr("legende", ", on real photos of the " + genre + ".")));
        } else {
          legendeExemple.forEach(function (n) { legende.appendChild(n.cloneNode(true)); });
        }
        /* 🔴 Décision 4 (lot 04) : une photo d'une AUTRE taille le dit, la taille commandée écrite en clair. */
        if (liste[0] && liste[0].note) legende.appendChild(document.createTextNode(" " + note(liste[0].note)));
      }
    }

    function peindreExemple() {
      var cle = cleExemple();
      if (cle && exemples[cle]) peindre(exemples[cle], false);
    }

    /* Les photos de LA famille, annoncées par le bloc. Une annonce vide (variante sans scène, famille
       pas prête) ramène l'exemple : jamais la photo d'une autre variante. */
    function recevoir(detail) {
      if (!detail || !detail.situations || !detail.situations.length || !detail.service) {
        famille = null;
        peindreExemple();
        return;
      }
      famille = detail;
      peindre(detail.situations.map(function (s) {
        return { src: detail.service + s.adresse, texte: s.texte || "", note: s.note || "",
          poser: detail.poser && s.recette ? function (img) { detail.poser(img, s); } : null };
      }), true);
    }

    /* 🔴 LOT 03 BOUTIQUE-CHAT — LE ZOOM DE LA PHOTO (décision F7 d'Alex, D-d). Ordinateur (survol fin) : loupe ×2 DANS le
       cadre, l'origine posée sous le pointeur (le point visé ne bouge pas) ; la sortie rend la photo. Clic, Entrée, Espace,
       et le toucher au téléphone : plein écran dans un <dialog> modal, Échap et la croix ferment, le focus revient à la
       photo. ⚠️ Aucun `touch-action` : le pincement du plein écran est celui du navigateur. Délégué sur la piste, il vaut
       pour l'exemple ET pour les photos de la famille, que `peindre` remplace. */
    var loupe = window.matchMedia ? window.matchMedia("(hover: hover) and (pointer: fine)") : null;
    var plein = null;
    var origine = null;

    function photoDe(cible) {
      var f = cible && cible.closest ? cible.closest("[data-tms-galerie-photo]") : null;
      return f && piste.contains(f) ? f : null;
    }

    /* La photo VISIBLE d'une figure : celle d'une famille encore en composition est cachée par le bloc (`tms-gallery.js`). */
    function imageDe(f) {
      var im = f ? f.querySelector("img") : null;
      return im && im.style.display !== "none" && (im.currentSrc || im.src) ? im : null;
    }

    /* (revue du lot) Une photo de la famille COMPOSÉE par le navigateur (lot 22, `pose.js`) : l'<img> ne porte qu'une
       image d'attente transparente (`data-tms-pose`), la composition est posée dans un hôte voisin. L'<img> ne grossit
       jamais (`placer` repose l'hôte d'après sa boîte, transformation comprise) : lot 26 (C5), la loupe grossit l'HÔTE,
       qui couvre la boîte de l'<img>. Son plein écran montre son repli. */
    function composee(im) { return im.hasAttribute("data-tms-pose"); }
    function hoteDe(f) { return f.querySelector("[data-tms-pose-hote]"); }

    function relacher() {
      photos().forEach(function (f) { f.removeAttribute("data-tms-loupe"); });
    }

    piste.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse" || !loupe || !loupe.matches) return;
      var f = photoDe(e.target), im = imageDe(f), h = im && composee(im) ? hoteDe(f) : null;
      if (!im || (composee(im) && !h)) return relacher();
      var r = (h ? im : f).getBoundingClientRect();
      photos().forEach(function (x) { if (x !== f) x.removeAttribute("data-tms-loupe"); });
      (h || im).style.transformOrigin = (e.clientX - r.left) + "px " + (e.clientY - r.top) + "px";
      f.setAttribute("data-tms-loupe", "");
    });
    piste.addEventListener("pointerleave", relacher);

    function pleinEcran(f) {
      var im = imageDe(f);
      if (!im) return;
      if (!plein) {
        plein = document.createElement("dialog");
        plein.className = "galerie-zoom";
        plein.setAttribute("aria-label", tr("plein", "Photo, full screen"));
        var fermer = document.createElement("button");
        fermer.type = "button";
        fermer.className = "galerie-zoom__fermer";
        fermer.setAttribute("aria-label", tr("fermer-plein", "Close full screen"));
        fermer.textContent = "×";
        fermer.autofocus = true;
        fermer.addEventListener("click", function () { plein.close(); });
        var vue = document.createElement("img");
        vue.className = "galerie-zoom__img";
        vue.decoding = "async";
        plein.appendChild(fermer);
        plein.appendChild(vue);
        plein.addEventListener("close", function () {
          if (origine && document.contains(origine)) origine.focus();
        });
        document.body.appendChild(plein);
      }
      /* Sans <dialog> natif, pas de plein écran : un voile posé par `open` n'aurait ni Échap ni `close()`. */
      if (typeof plein.showModal !== "function") return;
      var src = composee(im) ? f.__tmsRepli : im.currentSrc || im.src;
      if (!src) return;
      var grande = plein.querySelector(".galerie-zoom__img");
      grande.src = src;
      grande.alt = im.alt;
      origine = f;
      relacher();
      plein.showModal();
    }

    piste.addEventListener("click", function (e) {
      var f = photoDe(e.target);
      if (f) pleinEcran(f);
    });
    piste.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var f = photoDe(e.target);
      if (!f || e.target !== f) return;
      e.preventDefault();
      pleinEcran(f);
    });

    var attente = null;
    piste.addEventListener("scroll", function () {
      if (attente) return;
      attente = window.requestAnimationFrame(function () {
        attente = null;
        var ps = photos();
        if (!ps.length) return;
        var i = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
        if (i !== actif) choisir(i, false);
      });
    }, { passive: true });

    /* 🔴 LOT 07 — LA GRILLE CREUSE (le mug : la couleur n'existe qu'en 11 oz). Un choix qui forme une combinaison SANS
       variante corrige l'AUTRE option, en silence et AVANT le bloc : écouteur en phase de CAPTURE sur la section, donc
       avant celui du bloc sur la radio, qui lit alors une combinaison qui existe. Couleur choisie ⇒ la première taille
       qui l'a ; taille choisie ⇒ la première couleur qu'elle a (le blanc). Sinon le bloc garde l'ancienne variante au
       panier pendant que la page affiche la nouvelle taille. */
    function existe(taille, couleur) {
      return variantes.some(function (x) {
        return (!taille || x.taille === taille) && (!couleur || x.couleur === couleur);
      });
    }

    function radio(attr, valeur) {
      return Array.prototype.filter.call(section.querySelectorAll("input[" + attr + "]"), function (r) {
        return r.value === valeur;
      })[0] || null;
    }

    function harmoniser(cible) {
      var taille = coche("data-tms-taille"), couleur = coche("data-tms-couleur");
      if (!taille || !couleur || existe(taille, couleur)) return;
      var parTaille = cible && cible.hasAttribute("data-tms-taille");
      var v = variantes.filter(function (x) {
        return parTaille ? x.taille === taille : x.couleur === couleur;
      })[0];
      var r = v && (parTaille ? radio("data-tms-couleur", v.couleur) : radio("data-tms-taille", v.taille));
      if (r) r.checked = true;
    }
    section.addEventListener("change", function (e) {
      var t = e.target;
      if (t && t.matches && t.matches("input[data-tms-couleur], input[data-tms-taille]")) harmoniser(t);
      if (t && t.matches && t.matches("input[data-tms-couleur], input[data-tms-taille]")) suivreOrientation();
    }, true);
    harmoniser(null);
    suivreOrientation();

    section.querySelectorAll("input[data-tms-couleur], input[data-tms-taille], input[data-tms-emplacement], input[data-tms-papier], input[data-tms-epaisseur], input[data-tms-sens]").forEach(function (r) {
      r.addEventListener("change", function () {
        suivreTaille();
        /* Avec famille, le bloc rejoue `afficherPrete` et annonce les photos de la nouvelle variante. */
        if (!famille) peindreExemple();
      });
    });
    section.addEventListener("tms:situations", function (e) {
      recevoir(e.detail);
    });
    batirNavigation(null);
    /* 🔴 UNE TAILLE RESTAURÉE PAR LE NAVIGATEUR (retour arrière, rechargement) est cochée sans `change` : le bloc
       met déjà SA variante au panier, donc le prix, la matière et les photos la suivent dès le départ — sinon
       24 € affichés, 26 € facturés (revue du lot 03). */
    if (coche("data-tms-taille") || coche("data-tms-papier") || coche("data-tms-epaisseur")) {
      suivreTaille();
      if (cleExemple() !== cleDefaut) peindreExemple();
    }
    /* ⚠️ Le bloc a pu parler AVANT ce fichier (deux scripts différés) : il laisse sa dernière annonce
       sur la section. */
    if (section.__tmsSituations) recevoir(section.__tmsSituations);
  }


  /* 🔴 LOT 27 : LA FICHE DE LA MAQUETTE V2 (décisions 1 à 6 d'Alex, 24/10). Ce fichier MONTRE ; il ne décide rien de ce
     qui s'imprime ni de ce qui se paie. Tout geste passe par un contrôle SERVI du bloc d'app (radio, bouton, champ),
     qu'il actionne comme un client le ferait : le bloc reste seul juge du verrou, des crédits et du panier.
       · la grande image : avec famille, l'aperçu du bloc (ce qui s'imprime) est posé sur le cadre de la galerie
         (--fiche-img-*), et le rail ajoute sa vue « impression » devant les photos en situation ;
       · l'étape 1 dit les prénoms servis ; « Show names » et « Change the names » relaient les contrôles du bloc ;
       · l'étape 2 : trois formes et des menus par-dessus les radios, qui restent la source lue partout ;
       · « Make it yours » : cinq vignettes ; une gratuite s'applique au toucher, une « 1 scene » attend « Use 1 scene ». */
  function initFiche(fiche) {
    var section = fiche.closest(".shopify-section") || document;
    /* (boutique-langue) les textes écrits ici viennent de la PAGE (`data-t-*` de la section, rendus par `| t`) ;
       l'anglais n'est que le repli. */
    function trF(cle, defaut) { return fiche.getAttribute("data-t-" + cle) || defaut; }
    var bloc = fiche.querySelector("[data-tms-gallery]");
    var cadre = fiche.querySelector(".galerie-sit__cadre");
    var rail = fiche.querySelector("[data-tms-galerie-vignettes]");
    var genre = (fiche.querySelector("[data-tms-galerie]") || fiche).getAttribute("data-tms-genre") || "product";
    var variantes = (lireJSON(section.querySelector("script[data-tms-variantes]")) || []);

    function q(sel) { return bloc ? bloc.querySelector(sel) : null; }
    function vu(n) { return Boolean(n && !n.closest("[hidden]") && n.getClientRects().length); }
    function attr(n, nom, valeur) { if (n && n.getAttribute(nom) !== valeur) n.setAttribute(nom, valeur); }
    function cacher(n, oui) { if (n && n.hidden !== Boolean(oui)) n.hidden = Boolean(oui); }
    function prete() { var v = q('[data-tms-state="prete"]'); return Boolean(v && !v.hidden); }
    function changer(n) { n.dispatchEvent(new Event("change", { bubbles: true })); }

    /* ── la grande image ── */
    function placer() {
      if (!cadre) return;
      var f = fiche.getBoundingClientRect(), c = cadre.getBoundingClientRect();
      var v = { x: c.left - f.left, y: c.top - f.top, w: c.width, h: c.height };
      Object.keys(v).forEach(function (k) {
        var px = Math.round(v[k]) + "px";
        if (fiche.style.getPropertyValue("--fiche-img-" + k) !== px) fiche.style.setProperty("--fiche-img-" + k, px);
      });
    }
    function montrerVue(v) {
      attr(fiche, "data-fiche-vue", v);
      var b = rail && rail.querySelector(".galerie-sit__vignette--impression");
      if (b) attr(b, "aria-current", v === "impression" ? "true" : "false");
      if (v === "impression" && rail) {
        rail.querySelectorAll(".galerie-sit__vignette:not(.galerie-sit__vignette--impression)").forEach(function (x) {
          attr(x, "aria-current", "false");
        });
      }
      /* le calque de pose.js se replace sur l'image (il lit sa visibilité au placement) */
      window.dispatchEvent(new Event("resize"));
    }
    /* 🔴 LOT 29 (défaut 5) : UNE VIGNETTE NE MONTRE JAMAIS UN CADRE CASSÉ. Son image reste cachée jusqu'à son chargement
       (`data-fiche-charge`) ; une erreur (un aperçu encore en préparation répond 202, que l'<img> ne lit pas) la redemande,
       au plus REESSAIS fois, sans recharger la page. */
    var REESSAIS = 40, PAUSE_MS = 3000;
    function poserImage(im, src) {
      if (!im || !src || im.getAttribute("data-fiche-src") === src) return;
      im.setAttribute("data-fiche-src", src);
      im.setAttribute("data-fiche-charge", "");
      im.__ficheEssais = 0;
      if (!im.__ficheBranche) {
        im.__ficheBranche = true;
        im.addEventListener("load", function () {
          if (im.naturalWidth && im.getAttribute("src") === im.getAttribute("data-fiche-src")) im.removeAttribute("data-fiche-charge");
        });
        im.addEventListener("error", function () {
          var voulu = im.getAttribute("data-fiche-src");
          if (!voulu) return;
          /* (revue) épuisé : l'adresse est oubliée, la prochaine peinture la redemande (jamais un carré vide pour toujours) */
          if (++im.__ficheEssais > REESSAIS) return im.removeAttribute("data-fiche-src");
          window.setTimeout(function () {
            /* même adresse réaffectée : le navigateur la redemande (une image en échec n'est pas gardée) */
            if (im.getAttribute("data-fiche-src") === voulu) im.src = voulu;
          }, PAUSE_MS);
        });
      }
      im.src = src;
    }
    /* Le PRODUIT PORTÉ de SA famille, en petit : la première photo en situation que le bloc annonce (jamais celle d'une
       famille d'exemple). (revue) COMPOSÉE par le navigateur quand elle a sa recette (`poser`, lot 22 : le service ne
       la rend pas), sinon l'image du serveur, avec ses réessais. Rend `false` sans photo annoncée. */
    function produitPorte() {
      var d = section.__tmsSituations;
      var s = d && !d.exemple && d.situations && d.situations[0];
      return s && s.adresse && d.service ? { d: d, s: s, src: d.service + s.adresse } : null;
    }
    function poserPorte(im, p) {
      if (!im || !p) return;
      if (p.d.poser && p.s.recette && p.s.pose) {
        if (im.getAttribute("data-fiche-src") === p.src) return;
        im.setAttribute("data-fiche-src", p.src);
        im.removeAttribute("data-fiche-charge");
        p.d.poser(im, p.s);
        return;
      }
      poserImage(im, p.src);
    }
    function vueImpression() {
      if (!rail) return;
      var b = rail.querySelector(".galerie-sit__vignette--impression");
      var img = q("[data-tms-apercu]");
      if (!prete() || !img) {
        if (b) b.remove();
        if (fiche.hasAttribute("data-fiche-vue")) fiche.removeAttribute("data-fiche-vue");
        return;
      }
      /* (lot 29, défaut 5) l'adresse VRAIMENT à l'écran (`data-tms-affiche`, posée par le bloc quand l'aperçu est vu),
         jamais la cible demandée pendant que le service la prépare (`data-tms-cible`, 202) */
      var src = img.getAttribute("data-tms-affiche") || "";
      /* (revue) un style changé : tant que la NOUVELLE image n'est pas à l'écran, l'ancienne n'est plus « ce qui sera
         imprimé » — la vue se vide, et reprend la nouvelle dès qu'elle est vue */
      if (src && src !== img.getAttribute("data-tms-cible")) src = "";
      if (!b) {
        b = document.createElement("button");
        b.type = "button";
        b.className = "galerie-sit__vignette galerie-sit__vignette--impression";
        b.setAttribute("aria-label", trF("vue-impression", "Your " + genre + ", exactly as printed"));
        var im = document.createElement("img");
        im.alt = "";
        b.appendChild(im);
        b.addEventListener("click", function () { montrerVue("impression"); });
      }
      /* 🔴 LOT 29 (défaut 6, D4 d'Alex) : la grande image est le PRODUIT PORTÉ ; « ce qui sera imprimé » est la SECONDE vue
         du rail, montrée à la demande. */
      var premiere = rail.querySelector(".galerie-sit__vignette:not(.galerie-sit__vignette--impression)");
      if (b.parentNode !== rail || b.previousSibling !== premiere) {
        var place = premiere ? premiere.nextSibling : null;
        rail.insertBefore(b, place === b ? b.nextSibling : place);
      }
      if (!fiche.hasAttribute("data-fiche-vue")) montrerVue("situation");
      var vue = b.querySelector("img");
      if (src) poserImage(vue, src);
      else if (vue.hasAttribute("data-fiche-src")) {
        vue.removeAttribute("data-fiche-src");
        vue.setAttribute("data-fiche-charge", "");
      }
    }
    if (rail) {
      rail.addEventListener("click", function (e) {
        var b = e.target.closest && e.target.closest(".galerie-sit__vignette");
        if (b && !b.classList.contains("galerie-sit__vignette--impression")) montrerVue("situation");
      });
    }

    /* ── étape 1 : les prénoms, « Show names », « Change the names » ── */
    function liste(noms) {
      return noms.length < 2 ? noms.join("") : noms.slice(0, -1).join(", ") + trF("et", " and ") + noms[noms.length - 1];
    }
    var proxyNoms = fiche.querySelector("[data-fiche-prenoms]");
    var boutonNoms = fiche.querySelector("[data-fiche-noms]");
    function peindreNoms() {
      var qui = fiche.querySelector("[data-fiche-qui]");
      var noms = [];
      try { noms = JSON.parse((bloc && bloc.getAttribute("data-tms-prenoms")) || "[]") || []; } catch (e) { noms = []; }
      noms = noms.filter(function (n) { return n; });
      var membres = q("[data-tms-membres]");
      var texte = noms.length ? liste(noms) : (membres ? membres.textContent : "");
      if (qui && qui.textContent !== texte) qui.textContent = texte;
      var vrai = q("[data-tms-visuel-prenoms]");
      var avecCase = Boolean(vrai && !vrai.closest("[hidden]"));
      var details = q("[data-tms-noms]");
      var avecNoms = Boolean(details && !details.hidden);
      cacher(fiche.querySelector("[data-fiche-prenoms-case]"), !avecCase);
      cacher(boutonNoms, !avecNoms);
      cacher(fiche.querySelector("[data-fiche-noms-rangee]"), !(avecCase || avecNoms));
      if (avecCase && proxyNoms) {
        if (proxyNoms.checked !== vrai.checked) proxyNoms.checked = vrai.checked;
        if (proxyNoms.disabled !== vrai.disabled) proxyNoms.disabled = vrai.disabled;
      }
    }
    if (proxyNoms) {
      proxyNoms.addEventListener("change", function () {
        var vrai = q("[data-tms-visuel-prenoms]");
        if (!vrai || vrai.disabled) return;
        vrai.checked = proxyNoms.checked;
        changer(vrai);
      });
    }
    /* 🔴 LOT 29 (défauts 8, 9) : LES FENÊTRES DE LA FICHE. Un <dialog> modal (feuille du bas en 390, tms-fiche.css) : Échap,
       la croix ou un clic sur le voile ferment, le focus revient au geste qui l'a ouverte. Ce qu'on y fait passe par les
       contrôles SERVIS du bloc, comme partout ici. Sans <dialog> natif : `null`, l'appelant garde son ancien geste. */
    var fenetres = {};
    function fenetre(nom, titre) {
      if (fenetres[nom]) return fenetres[nom];
      var d = document.createElement("dialog");
      if (typeof d.showModal !== "function") return null;
      d.className = "fiche-fenetre";
      d.setAttribute("data-fiche-fenetre", nom);
      d.setAttribute("aria-labelledby", "fiche-fenetre-" + nom);
      var tete = document.createElement("div");
      tete.className = "fiche-fenetre__tete";
      var h = document.createElement("h2");
      h.className = "fiche-fenetre__titre";
      h.id = "fiche-fenetre-" + nom;
      h.textContent = titre;
      var x = document.createElement("button");
      x.type = "button";
      x.className = "fiche-fenetre__fermer";
      x.setAttribute("aria-label", trF("fermer", "Close"));
      x.textContent = "×";
      x.addEventListener("click", function () { d.close(); });
      tete.appendChild(h);
      tete.appendChild(x);
      var corps = document.createElement("div");
      corps.className = "fiche-fenetre__corps";
      d.appendChild(tete);
      d.appendChild(corps);
      d.addEventListener("click", function (e) { if (e.target === d) d.close(); });
      d.addEventListener("close", function () {
        if (d.__origine && document.contains(d.__origine)) d.__origine.focus();
      });
      fiche.appendChild(d);
      fenetres[nom] = { d: d, corps: corps };
      return fenetres[nom];
    }
    function ouvrir(f, origine, focus) {
      f.d.__origine = origine;
      f.d.showModal();
      if (focus) focus.focus();
    }

    /* Les prénoms : les champs SERVIS du bloc (`[data-tms-nom]`, leurs libellés) recopiés dans la fenêtre ; « Save » les
       réécrit et appuie sur l'enregistrement du bloc, « Cancel » ne touche à rien. Le panneau du bloc n'est plus montré. */
    function ouvrirNoms() {
      var champs = bloc ? Array.prototype.slice.call(bloc.querySelectorAll("[data-tms-nom]")) : [];
      var garder = q("[data-tms-noms-garder]");
      var titre = q("[data-tms-noms] summary");
      var f = champs.length && garder ? fenetre("noms", (titre && titre.textContent.trim()) || trF("noms", "Change the names")) : null;
      if (!f) {
        /* (revue) sans <dialog> natif (ou champs pas encore peints) : l'ancien geste, le panneau du bloc déplié */
        var details = q("[data-tms-noms]");
        if (!details) return false;
        details.setAttribute("data-fiche-ouvert", "");
        details.open = true;
        var c = details.querySelector("input") || details.querySelector("summary");
        if (c) c.focus();
        return true;
      }
      f.corps.textContent = "";
      var form = document.createElement("form");
      form.className = "fiche-fenetre__form";
      form.noValidate = true;
      var entrees = champs.map(function (c, i) {
        var p = document.createElement("p");
        p.className = "fiche-fenetre__champ";
        var l = document.createElement("label");
        var lib = bloc.querySelector('label[for="' + c.id + '"]');
        l.textContent = lib ? lib.textContent : "";
        l.htmlFor = "fiche-nom-" + i;
        var e = document.createElement("input");
        e.type = "text";
        e.id = "fiche-nom-" + i;
        e.value = c.value;
        e.autocomplete = "off";
        if (c.maxLength > 0) e.maxLength = c.maxLength;
        p.appendChild(l);
        p.appendChild(e);
        form.appendChild(p);
        return e;
      });
      var erreur = document.createElement("p");
      erreur.className = "fiche-fenetre__erreur";
      erreur.setAttribute("role", "alert");
      form.appendChild(erreur);
      var actions = document.createElement("p");
      actions.className = "fiche-fenetre__actions";
      var oui = document.createElement("button");
      oui.type = "submit";
      oui.className = "btn btn-action";
      oui.setAttribute("data-fiche-enregistrer", "");
      oui.textContent = trF("enregistrer", "Save");
      var non = document.createElement("button");
      non.type = "button";
      non.className = "lien";
      non.setAttribute("data-fiche-annuler", "");
      non.textContent = trF("annuler", "Cancel");
      non.addEventListener("click", function () { f.d.close(); });
      actions.appendChild(oui);
      actions.appendChild(non);
      form.appendChild(actions);
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var noms = entrees.map(function (x) { return x.value.trim(); });
        var vide = noms.indexOf("");
        if (vide >= 0) {
          erreur.textContent = trF("prenom-vide", "Every person needs a name.");
          entrees[vide].focus();
          return;
        }
        champs.forEach(function (c, i) { c.value = noms[i]; });
        garder.click();
        f.d.close();
      });
      f.corps.appendChild(form);
      ouvrir(f, boutonNoms, entrees[0]);
      return true;
    }
    if (boutonNoms) boutonNoms.addEventListener("click", ouvrirNoms);

    /* ── étape 2 : trois formes et des menus, par-dessus les radios ── */
    var FORMES = [["Square", "carre"], ["Portrait", "portrait"], ["Landscape", "paysage"]];
    function coche(attrRadio) {
      var r = section.querySelector("input[" + attrRadio + "]:checked");
      return r ? r.value : "";
    }
    function carree(taille) {
      return variantes.some(function (v) { return v.taille === taille && v.sens === "Square"; });
    }
    function formeCourante() {
      var t = coche("data-tms-taille");
      if (carree(t)) return "Square";
      var o = section.querySelector("[data-tms-orientations]");
      return (o && !o.hidden && coche("data-tms-sens")) || "Portrait";
    }
    var menus = [];
    var formes = null;
    function poserChoix() {
      var etape = fiche.querySelector(".etape__options");
      if (!etape) return;
      var titre = etape.querySelector(".etape__nom");
      var ligne = document.createElement("div");
      ligne.className = "choix-ligne";
      ligne.style.display = "contents";
      var tailles = etape.querySelector("[data-tms-tailles]");
      var sensDispo = FORMES.filter(function (f) {
        return variantes.some(function (v) { return v.sens === f[0] && v.dispo !== false; });
      });
      if (tailles && sensDispo.length > 1) {
        formes = document.createElement("fieldset");
        formes.className = "formes";
        formes.innerHTML = '<legend class="sr"></legend>';
        formes.querySelector("legend").textContent = trF("forme", "Shape");
        sensDispo.forEach(function (f) {
          var l = document.createElement("label");
          l.className = "forme";
          l.innerHTML = '<input type="radio" name="fiche-forme" value="' + f[0] + '"><span class="forme__trait forme__trait--' + f[1] + '" aria-hidden="true"></span>';
          l.appendChild(document.createTextNode(trF("forme_" + f[1], f[0])));
          formes.appendChild(l);
        });
        formes.addEventListener("change", function (e) { choisirForme(e.target.value); });
        ligne.appendChild(formes);
        var o = etape.querySelector("[data-tms-orientations]");
        if (o) o.setAttribute("data-fiche-proxy", "");
      }
      [["[data-tms-tailles]", "data-tms-taille"], ["[data-tms-papiers]", "data-tms-papier"],
        ["[data-tms-epaisseurs]", "data-tms-epaisseur"]].forEach(function (paire) {
        var fs = etape.querySelector(paire[0]);
        if (!fs) return;
        var legende = fs.querySelector("legend");
        var id = "fiche-menu-" + paire[1].replace("data-tms-", "");
        var l = document.createElement("label");
        l.className = "sr";
        l.htmlFor = id;
        l.textContent = legende ? legende.textContent : "";
        var s = document.createElement("select");
        s.className = "choix-menu";
        s.id = id;
        s.addEventListener("change", function () {
          var r = Array.prototype.filter.call(fs.querySelectorAll("input[" + paire[1] + "]"), function (x) {
            return x.value === s.value;
          })[0];
          if (!r || r.checked) return;
          r.checked = true;
          changer(r);
          if (paire[1] === "data-tms-taille") orienter(formeCourantePressee());
        });
        ligne.appendChild(l);
        ligne.appendChild(s);
        fs.setAttribute("data-fiche-proxy", "");
        menus.push({ fs: fs, attr: paire[1], select: s });
      });
      titre.parentNode.insertBefore(ligne, titre.nextSibling);
      peindreChoix();
    }
    function formeCourantePressee() {
      var r = formes && formes.querySelector("input:checked");
      return r ? r.value : formeCourante();
    }
    function orienter(forme) {
      /* une taille ORIENTABLE prend le sens de la forme (le bloc lance alors le redessin, au seul choix du client) */
      var o = section.querySelector("[data-tms-orientations]");
      if (!o || o.hidden || forme === "Square") return;
      var r = o.querySelector('input[data-tms-sens][value="' + forme + '"]');
      if (r && !r.checked) {
        r.checked = true;
        changer(r);
      }
    }
    function choisirForme(forme) {
      var t = coche("data-tms-taille");
      var veutCarree = forme === "Square";
      if (carree(t) !== veutCarree) {
        var r = Array.prototype.filter.call(section.querySelectorAll("input[data-tms-taille]"), function (x) {
          return carree(x.value) === veutCarree;
        })[0];
        if (r) {
          r.checked = true;
          changer(r);
        }
      }
      orienter(forme);
      peindreChoix(forme);
    }
    function peindreChoix(forcee) {
      var forme = forcee || formeCourante();
      if (formes) {
        formes.querySelectorAll("input").forEach(function (r) {
          if (r.checked !== (r.value === forme)) r.checked = r.value === forme;
        });
      }
      menus.forEach(function (m) {
        var radios = Array.prototype.slice.call(m.fs.querySelectorAll("input[" + m.attr + "]"));
        if (m.attr === "data-tms-taille" && formes) {
          radios = radios.filter(function (r) { return carree(r.value) === (forme === "Square"); });
        }
        var cles = radios.map(function (r) { return r.value; }).join("\n");
        if (m.select.getAttribute("data-cles") !== cles) {
          m.select.textContent = "";
          radios.forEach(function (r) {
            var o = document.createElement("option");
            o.value = r.value;
            /* le libellé SERVI de la valeur (tms-valeur, dans la langue de la page), jamais la valeur anglaise */
            var nom = r.closest("label") && r.closest("label").querySelector(".couleur__nom");
            o.textContent = (nom && nom.textContent.trim()) || r.value;
            m.select.appendChild(o);
          });
          m.select.setAttribute("data-cles", cles);
        }
        var c = m.fs.querySelector("input[" + m.attr + "]:checked");
        if (c && m.select.value !== c.value) m.select.value = c.value;
      });
    }

    /* ── « Make it yours » : cinq vignettes ── */
    var vigs = null, confirme = null, attente = null;
    function poserVignettes() {
      var fac = q("[data-tms-facultatif]");
      var modele = fiche.querySelector("template[data-fiche-vigs]");
      if (!fac || !modele || vigs) return;
      var frag = modele.content.cloneNode(true);
      var apres = q("[data-tms-compteur]") || fac.querySelector(".tms-facultatif__titre");
      fac.insertBefore(frag, apres ? apres.nextSibling : fac.firstChild);
      vigs = fac.querySelector("[data-fiche-bloc='vignettes']");
      /* les blocs du bloc d'app que juge fidelite/positions.py */
      fac.setAttribute("data-fiche-bloc", "option");
      var cpt = q("[data-tms-compteur]");
      if (cpt) cpt.setAttribute("data-fiche-bloc", "compteur");
      confirme = fac.querySelector("[data-fiche-confirme]");
      vigs.addEventListener("click", function (e) {
        var b = e.target.closest && e.target.closest("button.vig__b");
        if (!b) return;
        toucher(b.closest("[data-fiche-vig]").getAttribute("data-fiche-vig"));
      });
      confirme.querySelector("[data-fiche-confirme-oui]").addEventListener("click", depenser);
    }
    function styleNaturel() { return q('[data-tms-style-choix="naturel"]'); }
    function scenesDessinees() {
      return Array.prototype.filter.call(bloc ? bloc.querySelectorAll("[data-tms-style-choix]") : [], function (b) {
        return b.getAttribute("data-tms-style-choix") !== "naturel";
      });
    }
    function rendu(valeur) { return q('[data-tms-ia="famille"] input[data-tms-ia-rendu][value="' + valeur + '"]'); }
    function restantes() {
      var n = q("[data-tms-compteur-n]");
      return n && n.textContent !== "" ? Number(n.textContent) : null;
    }
    function toucher(cle) {
      var naturel = styleNaturel();
      if (cle === "tel-quel") {
        cacher(confirme, true);
        if (naturel && !q("[data-tms-style]").hidden && naturel.getAttribute("aria-pressed") !== "true" && !naturel.disabled) naturel.click();
        var tq = rendu("tel_quel");
        if (tq && !tq.checked && !tq.disabled) tq.click();
        return;
      }
      if (cle === "dessin") {
        cacher(confirme, true);
        var present = q("[data-tms-visuel-vignette]");
        var dessin = q("[data-tms-visuel-dessin]");
        if (present && !present.hidden && dessin && !dessin.disabled) return dessin.click();
        ouvrirDessin();
        return;
      }
      if (cle === "scene") {
        /* une scène DÉJÀ dessinée se reprend sans rien dépenser */
        var faite = scenesDessinees()[0];
        if (faite) {
          cacher(confirme, true);
          if (!faite.disabled) faite.click();
          return;
        }
        /* 🔴 LOT 30 (défaut 11) : la fenêtre « Imaginez votre scène » ; sans <dialog> natif, l'ancienne confirmation */
        cacher(confirme, true);
        if (ouvrirScene()) return;
      }
      if (cle === "brode") {
        var prix = q('[data-tms-ia="famille"] [data-tms-ia-prix]');
        var b = rendu("brode");
        if (b && prix && prix.hidden) {
          cacher(confirme, true);
          if (!b.checked && !b.disabled) b.click();
          return;
        }
      }
      attente = cle;
      var phrase = cle === "scene" ? trF("confirme-scene", "A new drawing of your family, in a scene made for you.")
        : trF("confirme-brode", "Your family with a stitched look, drawn for you.");
      /* (revue) plus aucune scène : la phrase et le bouton sont ceux du panneau, déjà substitués par le bloc
         (« Get 5 more for €1 »), jamais le gabarit brut ; le bouton mène donc à l'achat du pack, pas à une dépense */
      var n = restantes();
      var pack = q("[data-tms-scene]");
      var offre = pack && pack.querySelector("[data-tms-scene-offre]");
      var acheter = pack && pack.querySelector("[data-tms-scene-form] [type=submit]");
      var oui = confirme.querySelector("[data-fiche-confirme-oui]");
      if (!oui.hasAttribute("data-t-defaut")) oui.setAttribute("data-t-defaut", oui.textContent);
      var vide = cle === "scene" && n === 0 && offre && offre.textContent.trim() ? offre.textContent.trim() : "";
      if (vide) phrase = vide;
      oui.textContent = vide && acheter && acheter.textContent.trim() ? acheter.textContent.trim() : oui.getAttribute("data-t-defaut");
      confirme.querySelector("[data-fiche-confirme-texte]").textContent = phrase;
      cacher(confirme, false);
      confirme.querySelector("[data-fiche-confirme-oui]").focus();
    }
    /* 🔴 LOT 30 (défaut 11, décision 5 d'Alex) : « Dans une scène » ouvre « Imaginez votre scène » — un champ LIBRE (borne
       servie, 160), les trois idées en un toucher, « Avec décor / Sans décor (juste vous) », et UN bouton qui est la seule
       dépense (« Dessiner · 1 scène », « Essayer gratuitement » pour l'offerte, l'achat du pack quand il n'en reste plus).
       Tout passe par le formulaire SERVI du bloc (texte, `decor`, envoi) ; ses refus et ses erreurs, écrits dans sa note
       (`[data-tms-scene-note]`), sont recopiés dans la fenêtre, qui se ferme quand le dessin part. */
    function ouvrirScene() {
      var panneau = q("[data-tms-scene]");
      var form = panneau && panneau.querySelector("[data-tms-scene-form]");
      var champ = panneau && panneau.querySelector("[data-tms-scene-texte]");
      if (!form || !champ) return false;
      var f = fenetre("scene", trF("scene-titre", "Imagine your scene"));
      if (!f) return false;
      if (!f.pret) {
        f.pret = true;
        var formF = document.createElement("form");
        formF.className = "fiche-fenetre__form";
        formF.noValidate = true;
        var phrase = document.createElement("p");
        phrase.className = "fiche-fenetre__phrase";
        phrase.textContent = trF("scene-phrase", "Write where you are and what you are doing, or pick an idea.");
        var lib = panneau.querySelector("label[for='" + champ.id + "']");
        var l = document.createElement("label");
        l.htmlFor = "fiche-scene-texte";
        l.className = "fiche-fenetre__label";
        l.textContent = lib ? lib.textContent : "";
        var texte = document.createElement("textarea");
        texte.id = "fiche-scene-texte";
        texte.className = "fiche-scene__champ";
        texte.rows = 2;
        texte.setAttribute("data-fiche-scene-texte", "");
        texte.placeholder = champ.getAttribute("placeholder") || "";
        var idees = document.createElement("ul");
        idees.className = "fiche-scene__idees";
        idees.addEventListener("click", function (e) {
          var x = e.target.closest ? e.target.closest("[data-fiche-scene-idee]") : null;
          if (!x) return;
          texte.value = x.getAttribute("data-fiche-scene-texte-idee") || x.textContent.trim();
          /* (lot 33, R9) l'idée pose aussi SON décor : le câlin « sans décor », les autres « avec » */
          var dx = x.getAttribute("data-fiche-scene-idee-decor");
          if (dx !== null) {
            decor.querySelectorAll("input[name='fiche-scene-decor']").forEach(function (r) { r.checked = r.value === dx; });
          }
          erreur.textContent = "";
          texte.focus();
        });
        var decor = document.createElement("fieldset");
        decor.className = "fiche-scene__decor";
        var erreur = document.createElement("p");
        erreur.className = "fiche-fenetre__erreur";
        erreur.setAttribute("role", "alert");
        erreur.setAttribute("data-fiche-scene-erreur", "");
        var actions = document.createElement("p");
        actions.className = "fiche-fenetre__actions";
        var oui = document.createElement("button");
        oui.type = "submit";
        oui.className = "btn btn-action";
        oui.setAttribute("data-fiche-scene-dessiner", "");
        actions.appendChild(oui);
        [phrase, l, texte, idees, decor, erreur, actions].forEach(function (x) { formF.appendChild(x); });
        f.corps.appendChild(formF);
        f.texte = texte;
        f.erreur = erreur;
        f.oui = oui;
        f.idees = idees;
        f.decor = decor;
        formF.addEventListener("submit", function (e) {
          e.preventDefault();
          /* 🔴 LA SEULE DÉPENSE : le texte tel quel, le décor choisi, puis l'envoi du formulaire SERVI */
          champ.value = texte.value;
          var choisi = formF.querySelector("input[name='fiche-scene-decor']:checked");
          panneau.querySelectorAll("[data-tms-scene-decor-choix]").forEach(function (r) {
            r.checked = Boolean(choisi) && r.value === choisi.value;
          });
          erreur.textContent = "";
          f.attend = true;
          if (typeof form.requestSubmit === "function") form.requestSubmit();
          else form.dispatchEvent(new Event("submit", { cancelable: true }));
        });
        /* la note du bloc dit refus, erreur, ou départ du dessin : recopiée tant que la fenêtre attend sa réponse */
        var note = panneau.querySelector("[data-tms-scene-note]");
        var suivre = function () {
          if (!f.attend || !f.d.open) return;
          var etat = panneau.getAttribute("data-tms-scene-etat") || "";
          if (etat === "dessin" || etat === "paiement") {
            f.attend = false;
            f.d.close();
            return;
          }
          var dit = note ? note.textContent.trim() : "";
          if (dit && dit !== (panneau.getAttribute("data-t-envoi") || "")) erreur.textContent = dit;
        };
        if (window.MutationObserver) {
          var obs = new MutationObserver(suivre);
          if (note) obs.observe(note, { childList: true, characterData: true, subtree: true });
          obs.observe(panneau, { attributes: true, attributeFilter: ["data-tms-scene-etat"] });
        }
      }
      /* (revue) les idées et le choix du décor sont RELUS dans le bloc à chaque ouverture : il a pu les repeindre (langue,
         famille, choix fait ailleurs) ; ses libellés sont dans la langue de la page */
      f.idees.textContent = "";
      panneau.querySelectorAll("[data-tms-scene-exemple]").forEach(function (b) {
        var li = document.createElement("li");
        var x = document.createElement("button");
        x.type = "button";
        x.className = "fiche-scene__idee";
        x.setAttribute("data-fiche-scene-idee", b.getAttribute("data-tms-scene-idee") || "");
        var mot = b.getAttribute("data-tms-scene-exemple") || b.textContent;
        x.setAttribute("data-fiche-scene-texte-idee", mot);
        if (b.hasAttribute("data-tms-scene-decor")) x.setAttribute("data-fiche-scene-idee-decor", b.getAttribute("data-tms-scene-decor"));
        /* 🔴 LOT 33 (R9) : l'idée se VOIT — son image, rendue une fois par le service sur la famille d'exemple, au-dessus
           de son texte ; l'image est décorative (`alt=""`), le texte du bouton la nomme. */
        var src = b.getAttribute("data-tms-scene-image");
        if (src) {
          x.className += " fiche-scene__idee--image";
          var im = document.createElement("img");
          im.className = "fiche-scene__idee-img";
          im.src = src;
          im.alt = "";
          im.width = 160;
          im.height = 160;
          im.decoding = "async";
          x.appendChild(im);
        }
        var t = document.createElement("span");
        t.className = "fiche-scene__idee-texte";
        t.textContent = mot;
        x.appendChild(t);
        li.appendChild(x);
        f.idees.appendChild(li);
      });
      f.decor.textContent = "";
      var leg = document.createElement("legend");
      var legServie = panneau.querySelector("[data-tms-scene-decor] legend");
      leg.textContent = legServie ? legServie.textContent : "";
      f.decor.appendChild(leg);
      panneau.querySelectorAll("[data-tms-scene-decor-choix]").forEach(function (r) {
        var lab = document.createElement("label");
        lab.className = "fiche-scene__decor-choix";
        var i = document.createElement("input");
        i.type = "radio";
        i.name = "fiche-scene-decor";
        i.value = r.value;
        i.checked = r.checked;
        i.setAttribute("data-fiche-scene-decor", r.value);
        lab.appendChild(i);
        lab.appendChild(document.createTextNode(" " + (r.parentNode.textContent || "").trim()));
        f.decor.appendChild(lab);
      });
      if (champ.maxLength > 0) f.texte.maxLength = champ.maxLength;
      f.erreur.textContent = "";
      f.attend = false;
      /* le bouton dit ce qu'il fait : l'offerte s'essaie gratuitement, la suivante coûte une scène, sans scène c'est le pack */
      var n = restantes();
      var acheter = form.querySelector("[type=submit]");
      if (n === 0 && acheter && acheter.textContent.trim()) f.oui.textContent = acheter.textContent.trim();
      else if (panneau.getAttribute("data-tms-scene-offerte") === "oui") f.oui.textContent = trF("scene-essai", "Try it free");
      else f.oui.textContent = trF("scene-dessiner", "Draw · 1 scene");
      ouvrir(f, vigs && vigs.querySelector('[data-fiche-vig="scene"] .vig__b'), f.texte);
      return true;
    }
    /* 🔴 LOT 29 (défaut 9) : « Your drawing » ouvre une fenêtre qui dit à quoi sert le dessin, avec un dépôt et « Choose a
       photo », puis des conseils — jamais le sélecteur de fichier brut. Le fichier, choisi ou déposé, va dans le champ
       SERVI du bloc (`[data-tms-visuel-fichier]`), qui l'envoie et le pose sur le produit. Sans <dialog> : l'ancien geste. */
    function ouvrirDessin() {
      var fichier = q("[data-tms-visuel-fichier]");
      if (!fichier || fichier.disabled) return;
      var f = fenetre("dessin", trF("dessin-titre", "Your drawing"));
      if (!f) return fichier.click();
      if (!f.pret) {
        f.pret = true;
        var phrase = document.createElement("p");
        phrase.className = "fiche-fenetre__phrase";
        phrase.textContent = trF("dessin-phrase", "Your child's drawing (or a photo), printed exactly as it is next to your family. Free.");
        var depot = document.createElement("div");
        depot.className = "fiche-depot";
        depot.setAttribute("data-fiche-depot", "");
        var dit = document.createElement("p");
        dit.className = "fiche-depot__texte";
        dit.textContent = trF("dessin-depot", "Drop the photo of the drawing here");
        var choisir = document.createElement("button");
        choisir.type = "button";
        choisir.className = "btn btn-2 fiche-depot__choisir";
        choisir.setAttribute("data-fiche-choisir", "");
        choisir.textContent = trF("dessin-choisir", "Choose a photo");
        /* ⚠️ le champ du bloc est hors de la fenêtre modale, donc INERTE : la fenêtre a son propre champ, dont le fichier
           passe au champ du bloc (même `accept` ; sans `capture`, le téléphone propose l'appareil photo ET la galerie) */
        var propre = document.createElement("input");
        propre.type = "file";
        propre.accept = fichier.getAttribute("accept") || "image/*";
        propre.hidden = true;
        propre.tabIndex = -1;
        propre.addEventListener("change", function () {
          if (propre.files && propre.files.length) donner(propre.files);
          propre.value = "";
        });
        choisir.addEventListener("click", function () { propre.click(); });
        var format = document.createElement("p");
        format.className = "fiche-depot__format";
        format.textContent = trF("dessin-format", "JPEG, PNG or WebP, up to 15 MB.");
        depot.appendChild(dit);
        depot.appendChild(choisir);
        depot.appendChild(format);
        /* (revue) TOUTE la fenêtre reçoit le dépôt : un fichier lâché à côté de la zone n'ouvre jamais l'image dans l'onglet */
        ["dragenter", "dragover"].forEach(function (t) {
          f.d.addEventListener(t, function (e) { e.preventDefault(); depot.setAttribute("data-survol", ""); });
        });
        f.d.addEventListener("dragleave", function (e) { if (e.target === f.d) depot.removeAttribute("data-survol"); });
        f.d.addEventListener("drop", function (e) {
          e.preventDefault();
          depot.removeAttribute("data-survol");
          var fs = e.dataTransfer && e.dataTransfer.files;
          if (fs && fs.length) donner(fs);
        });
        var donner = function (fs) {
          try {
            /* (revue) une COPIE de la liste : vider le champ de la fenêtre ne vide pas celui du bloc */
            var dt = new DataTransfer();
            Array.prototype.forEach.call(fs, function (x) { dt.items.add(x); });
            fichier.files = dt.files;
          } catch (err) {
            return;   /* navigateur sans affectation de fichiers : la fenêtre reste ouverte, rien n'est perdu */
          }
          changer(fichier);
        };
        depot.appendChild(propre);
        var titre = document.createElement("p");
        titre.className = "fiche-fenetre__sous-titre";
        titre.textContent = trF("dessin-conseils", "For a clean print:");
        var ul = document.createElement("ul");
        ul.className = "fiche-fenetre__conseils";
        [["dessin-conseil-lumiere", "Good light, no shadow on the paper."],
          ["dessin-conseil-plat", "Flat on a table, photographed from straight above."],
          ["dessin-conseil-mobile", "On a phone: take the photo now, or pick it from your gallery."]].forEach(function (c) {
          var li = document.createElement("li");
          li.textContent = trF(c[0], c[1]);
          ul.appendChild(li);
        });
        f.corps.appendChild(phrase);
        f.corps.appendChild(depot);
        f.corps.appendChild(titre);
        f.corps.appendChild(ul);
        /* un fichier choisi (bouton ou dépôt) : le bloc le prend, la fenêtre a fini son travail */
        fichier.addEventListener("change", function () { if (f.d.open) f.d.close(); });
      }
      ouvrir(f, vigs && vigs.querySelector('[data-fiche-vig="dessin"] .vig__b'), f.d.querySelector("[data-fiche-choisir]"));
    }
    function depenser() {
      var cle = attente;
      attente = null;
      cacher(confirme, true);
      if (cle === "scene") {
        var panneau = q("[data-tms-scene]");
        var form = panneau && panneau.querySelector("[data-tms-scene-form]");
        var champ = panneau && panneau.querySelector("[data-tms-scene-texte]");
        var idee = panneau && panneau.querySelector("[data-tms-scene-exemple]");
        if (!form || !champ) return;
        if (!champ.value && idee) {
          champ.value = idee.getAttribute("data-tms-scene-exemple") || idee.textContent || "";
          var dIdee = idee.getAttribute("data-tms-scene-decor");      /* (lot 33) l'idée porte son décor */
          if (dIdee !== null) panneau.querySelectorAll("[data-tms-scene-decor-choix]").forEach(function (r) { r.checked = r.value === dIdee; });
        }
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { cancelable: true }));
      } else if (cle === "brode") {
        var b = rendu("brode");
        if (b && !b.disabled) b.click();
      }
    }
    function peindreVignettes() {
      if (!vigs) return;
      var naturel = styleNaturel();
      var faite = scenesDessinees().filter(function (b) { return b.getAttribute("aria-pressed") === "true"; })[0];
      var brode = rendu("brode");
      var dessin = q("[data-tms-visuel-dessin]");
      var travail = (bloc && bloc.getAttribute("data-tms-travail")) || "";
      var etats = {
        "tel-quel": { dispo: true, presse: !faite && !(brode && brode.checked) },
        "scene": { dispo: Boolean(q("[data-tms-scene]") && !q("[data-tms-scene]").hidden), presse: Boolean(faite) },
        "dessin": { dispo: Boolean(q("[data-tms-visuel]") && !q("[data-tms-visuel]").hidden), presse: Boolean(dessin && dessin.checked) },
        /* (lot 29, défaut 7, D3 d'Alex) seulement sur une variante que Gelato BRODE : la donnée du service, annoncée par le
           bloc avec ses photos (`broderie`) — jamais l'état de la composition seul. (revue) Déjà CHOISI, il reste montré
           (pressé) : un choix en cours ne se cache pas, il doit pouvoir se voir et se défaire. */
        "brode": { dispo: Boolean(q('[data-tms-ia="famille"]') && !q('[data-tms-ia="famille"]').hidden
          && ((section.__tmsSituations && section.__tmsSituations.broderie) || Boolean(brode && brode.checked))),
          presse: Boolean(brode && brode.checked) },
        "personnes": { dispo: true, presse: false }
      };
      if (naturel && naturel.getAttribute("aria-pressed") === "false" && !faite) etats["tel-quel"].presse = false;
      /* 🔴 LOT 29 (défauts 5, 10) : « As drawn » montre le PRODUIT PORTÉ tel que dessiné, et une scène FAITE montre la
         sienne, sans « Example » — chacune prise quand elle est le choix en cours (la photo annoncée est alors la sienne),
         puis gardée. */
      var porte = produitPorte();
      if (porte && etats["tel-quel"].presse) poserPorte(vigs.querySelector("[data-fiche-vig-famille]"), porte);
      var vScene = vigs.querySelector('[data-fiche-vig="scene"]');
      if (porte && faite && vScene) {
        poserPorte(vScene.querySelector(".vig__img"), porte);
        vScene.setAttribute("data-fiche-sienne", "");
      }
      Object.keys(etats).forEach(function (cle) {
        var li = vigs.querySelector('[data-fiche-vig="' + cle + '"]');
        if (!li) return;
        cacher(li, !etats[cle].dispo);
        var b = li.querySelector("button.vig__b");
        if (b) attr(b, "aria-pressed", etats[cle].presse ? "true" : "false");
        var cours = li.querySelector(".vig__cours");
        cacher(cours, !((cle === "scene" && travail === "scene") || (cle === "brode" && travail === "broderie")));
      });
      /* le travail en cours se dit dans le compteur : la phrase que le bloc écrit (role="status", lue là où elle est) */
      if ((fiche.getAttribute("data-fiche-travail") || "") !== travail) {
        if (travail) fiche.setAttribute("data-fiche-travail", travail);
        else fiche.removeAttribute("data-fiche-travail");
      }
      var cpt = q("[data-tms-compteur]");
      var cours = cpt && cpt.querySelector(".fiche-cours");
      var source = travail === "scene" ? q("[data-tms-scene-note]") : travail === "broderie" ? q("[data-tms-visuel-note]") : null;
      /* sa première phrase seulement (la maquette : une ligne, « Drawing your picnic… ») ; le reste est lu sur la note même */
      var dit = source ? (source.textContent.trim().match(/^[\s\S]*?[.!?][\u201d"]?(?=\s|$)/) || [source.textContent.trim()])[0] : "";
      if (cpt && dit && !cours) {
        cours = document.createElement("p");
        cours.className = "fiche-cours";
        cours.setAttribute("aria-hidden", "true");
        cpt.appendChild(cours);
      }
      if (cours && !dit) cours.remove();
      else if (cours && cours.textContent !== dit) cours.textContent = dit;
      /* la bulle « ? » de chaque badge « 1 scene » dit la phrase du compteur, comme les bulles du bloc */
      var phrase = q("[data-tms-compteur-phrase]");
      vigs.querySelectorAll("[data-tms-bulle-texte]").forEach(function (t) {
        if (phrase && t.textContent !== phrase.textContent) t.textContent = phrase.textContent;
      });
    }

    /* ── tout se relit sur ce que le bloc peint : un seul repeint par image ── */
    var prevu = false;
    function repeindre() {
      if (prevu) return;
      prevu = true;
      window.requestAnimationFrame(function () {
        prevu = false;
        poserVignettes();
        placer();
        vueImpression();
        peindreNoms();
        peindreChoix();
        peindreVignettes();
      });
    }
    poserChoix();
    if (bloc && window.MutationObserver) {
      new MutationObserver(repeindre).observe(bloc, { subtree: true, childList: true, attributes: true,
        attributeFilter: ["hidden", "aria-pressed", "src", "data-tms-cible", "data-tms-prenoms", "data-tms-travail", "disabled"] });
    }
    if (rail && window.MutationObserver) new MutationObserver(repeindre).observe(rail, { childList: true });
    if (window.ResizeObserver && cadre) new ResizeObserver(repeindre).observe(cadre);
    window.addEventListener("resize", function () { placer(); });
    section.addEventListener("change", function () { window.setTimeout(repeindre, 0); });
    /* (lot 29) les photos annoncées (produit porté, `broderie` de la variante) se relisent à chaque annonce */
    section.addEventListener("tms:situations", repeindre);
    repeindre();
  }

  /* 🔴 (lot 28 comptes, D2) « MORE PEOPLE » MÈNE À MY FAMILY, OUVERTE SUR L'AJOUT, ET REVIENT ICI : l'adresse de CETTE fiche
     (langue comprise) et la variante choisie (`?variant=`, que Shopify relit) sont gardées dans l'onglet ; My family
     offre « Back to <produit> » (tms-gallery.js). Rien ne part ailleurs que dans `sessionStorage`. */
  function garderRetour(ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest("[data-fiche-retour]") : null;
    if (!a) return;
    var champ = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var url = window.location.pathname + (champ && champ.value ? "?variant=" + encodeURIComponent(champ.value) : "");
    try {
      window.sessionStorage.setItem("tms_retour_fiche", JSON.stringify({
        url: url, nom: a.getAttribute("data-fiche-retour-nom") || "" }));
    } catch (e) {
      /* stockage refusé : My family s'ouvre quand même, sans le retour */
    }
  }

  function demarrer() {
    document.addEventListener("click", garderRetour, true);
    document.querySelectorAll("[data-tms-galerie]").forEach(initGalerie);
    document.querySelectorAll(".fiche[data-fiche-bloc='colonne'], section.fiche").forEach(initFiche);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
})();
